import { VotingRemainingDays } from "src/components/common/voting/voting-remaining-days";
import { calculateVotingEndDate } from "../../utils/calculate-voting-end-date";

interface IVotingTimeLeftProps {
    articleCreationDate: string;
    weekdaysCount?: number;
}

export function VotingTimeLeft({ articleCreationDate, weekdaysCount = 1 }: IVotingTimeLeftProps) {
    const now = new Date();
    const voteUntilDate = calculateVotingEndDate(new Date(articleCreationDate), weekdaysCount);

    return <VotingRemainingDays votingUntilDate={voteUntilDate.toISOString()} currentDate={now.toISOString()} />;
}
